import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { CasesRoutingModule } from './cases-routing.module';
import { CaseListComponent } from './components/case-list/case-list.component';
import { CaseFormComponent } from './components/case-form/case-form.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';

import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core'; // This is optional, often included via MatSelectModule
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { SearchComponent } from '../../shared/components/search/search.component';
import { FileUploaderComponent } from '../../shared/components/file-uploader/file-uploader.component';

@NgModule({
  declarations: [
    CaseListComponent,
    CaseFormComponent
  ],
  imports: [
    CommonModule,
    CasesRoutingModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatPaginatorModule,
    MatIconModule,
    FormsModule,
    MatDatepickerModule,
    MatNativeDateModule, // This provides the native DateAdapter
    MatSelectModule,
    MatOptionModule, // This is optional, often included via MatSelectModule
    MatCheckboxModule,
    MatDialogModule,
    MatButtonModule,
    SearchComponent,
    FileUploaderComponent
  ]
})
export class CasesModule { }
